module.exports = __webpack_public_path__ + "static/img/1-1.706637e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/1-1.png
// module id = 1eeo
// module chunks = 0